export const creditCardConstants = {
  CARD_STATUS_IACT: "IACT",
  CARD_STATUS_CACT: "CACT",
  CARD_STATUS_CAPC: "CAPC",
  CARD_STATUS_CDEA: "CDEA",
  CARD_STATUS_CAEX: "CAEX",
  CARD_STATUS_CARP: "CARP",
  CARD_STATUS_CATB: "CATB",
  CARD_STATUS_CAPB: "CAPB",
  CARD_STATUS_VALID_CARD: "VALID CARD",

  ELIGIBLE_OPERATING_TYPE_LIST: ["VIEW_AND_TRANSFERS", "VIEW_ONLY"],
  ELIGIBLE_WALLET_OPERATING_TYPE_LIST: ["VIEW_AND_TRANSFERS"],

  CREDIT_CARD_TYPE_VISA_CREDIT: "VISA CREDIT",
  CREDIT_CARD_TYPE_MASTER_CREDIT: "MASTER CREDIT",

  // Card type identifiers for .includes() checks
  CARD_TYPE_MASTER: "MASTER",

  CREDIT_CARD_CASHBACK_DETAILS_REQUEST: "CREDIT_CARD_CASHBACK_DETAILS_REQUEST",
  CREDIT_CARD_CASHBACK_DETAILS_COMPLETE:
    "CREDIT_CARD_CASHBACK_DETAILS_COMPLETE",
  CREDIT_CARD_CASHBACK_DETAILS_ERROR: "CREDIT_CARD_CASHBACK_DETAILS_ERROR",

  CREDIT_CARD_TRANSACTION_LIST_REQUEST: "CREDIT_CARD_TRANSACTION_LIST_REQUEST",
  CREDIT_CARD_TRANSACTION_LIST_COMPLETE:
    "CREDIT_CARD_TRANSACTION_LIST_COMPLETE",
  CREDIT_CARD_TRANSACTION_LIST_ERROR: "CREDIT_CARD_TRANSACTION_LIST_ERROR",

  CREDIT_CARD_STATEMENT_LIST_REQUEST: "CREDIT_CARD_STATEMENT_LIST_REQUEST",
  CREDIT_CARD_STATEMENT_LIST_COMPLETE: "CREDIT_CARD_STATEMENT_LIST_COMPLETE",
  CREDIT_CARD_STATEMENT_LIST_ERROR: "CREDIT_CARD_STATEMENT_LIST_ERROR",

  CREDIT_CARD_STATEMENT_DETAILS_REQUEST:
    "CREDIT_CARD_STATEMENT_DETAILS_REQUEST",
  CREDIT_CARD_STATEMENT_DETAILS_COMPLETE:
    "CREDIT_CARD_STATEMENT_DETAILS_COMPLETE",
  CREDIT_CARD_STATEMENT_DETAILS_ERROR: "CREDIT_CARD_STATEMENT_DETAILS_ERROR",

  CREDIT_CARD_SUPPLEMENTARY_DETAILS_REQUEST:
    "CREDIT_CARD_SUPPLEMENTARY_DETAILS_REQUEST",
  CREDIT_CARD_SUPPLEMENTARY_DETAILS_COMPLETE:
    "CREDIT_CARD_SUPPLEMENTARY_DETAILS_COMPLETE",
  CREDIT_CARD_SUPPLEMENTARY_DETAILS_ERROR:
    "CREDIT_CARD_SUPPLEMENTARY_DETAILS_ERROR",

  CREDIT_CARD_LENGTH_WITH_SPACES: 23,
  CREDIT_CARD_LENGTH_WITHOUT_SPACES: 19,

  DEBIT_CARD_LENGTH_WITHOUT_SPACES: 16,

  CREDIT_CARDS: "CREDIT_CARDS",
  DEBIT_CARDS: "DEBIT_CARDS",

  DEBIT_CARD_DETAILS_REQUEST: "DEBIT_CARD_DETAILS_REQUEST",
  DEBIT_CARD_DETAILS_COMPLETE: "DEBIT_CARD_DETAILS_COMPLETE",
  DEBIT_CARD_DETAILS_ERROR: "DEBIT_CARD_DETAILS_ERROR",

  DEBIT_CARD_TRANSACTION_HISTORY_REQUEST:
    "DEBIT_CARD_TRANSACTION_HISTORY_REQUEST",
  DEBIT_CARD_TRANSACTION_HISTORY_COMPLETE:
    "DEBIT_CARD_TRANSACTION_HISTORY_COMPLETE",
  DEBIT_CARD_TRANSACTION_HISTORY_ERROR: "DEBIT_CARD_TRANSACTION_HISTORY_ERROR",
};
